import { FC } from "react";
import { Box, List, ListItemIcon } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { CommonUtils } from "@/utils";
import { ListItemTextName, ListItemTextSize, ListItem } from "./SelectedFiles.style";

type SelectedFilesProps = { files?: File[]; showFile?: boolean };

const SelectedFiles: FC<SelectedFilesProps> = ({ files, showFile = false }) => {
  return (
    <List>
      {files?.map(file => (
        <ListItem key={file.name}>
          <ListItemIcon>
            <UploadFile color="primary" />
          </ListItemIcon>
          <Box>
            <ListItemTextName primary={file.name} />
            {showFile && <ListItemTextSize primary={CommonUtils.convertBytes(file.size)} />}
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export default SelectedFiles;
